<!--
* @description 政策兑现与发布量弹窗
* @fileName demandDialog.vue
* @author xuesong
* @date 2022/02/08 18:57:01
!-->
<template>
  <div id="DemandDialog">
    <div class="wrapper">
      <div class="wrapper-left">
        <div class="left-title">政策兑现数量</div>
        <div class="switch">
          <el-radio-group v-model="type" @change="typeChange">
            <el-radio-button label="申请企业数"></el-radio-button>
            <el-radio-button label="政策申请数"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="select">
          <el-select v-model="yaer" placeholder="请选择" @change="selectYear">
            <el-option
              v-for="item in yearOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
        <div id="barChart" ref="barChart"></div>
      </div>
      <div class="wrapper-right">
        <div class="right-title">政策发布列表</div>
        <div class="table-wrapper">
          <div class="table-header">
            <div class="header1">排名</div>
            <div class="header2">部门名称</div>
            <div class="header3">发布政策数</div>
          </div>
          <vue-seamless-scroll
            :data="listData"
            :class-option="classOption"
            class="table-body"
          >
            <div class="table-list">
              <div class="line" v-for="(item, index) in listData" :key="index">
                <div class="line-item1">
                  <div class="round">{{ index + 1 }}</div>
                </div>
                <div class="line-item2" :title="item.name">{{ item.name }}</div>
                <div class="line-item3">{{ item.val }}</div>
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'PolicyDialog',
  data() {
    return {
      barChart: null,
      type: '申请企业数',
      yaer: '2022年',
      // month: '1月',
      // monthOptions: [
      //   '1月',
      //   '2月',
      //   '3月',
      //   '4月',
      //   '5月',
      //   '6月',
      //   '7月',
      //   '8月',
      //   '9月',
      //   '10月',
      //   '11月',
      //   '12月'
      // ],
      xdata1: ['9月', '10月', '11月', '12月'],
      xdata2: ['1月', '2月'],
      yearOptions: ['2022年', '2021年'],
      // town: [
      //   '青田县',
      //   '莲都区',
      //   '缙云县',
      //   '遂昌县',
      //   '松阳县',
      //   '云和县',
      //   '庆元县',
      //   '景宁县',
      //   '龙泉市',
      //   '景宁畲族自治县'
      // ],
      ydata1: [null, null, null, null],
      ydata2: [null, null],
      listData: [
        {
          name: '青田县市场监督管理局',
          val: 80
        },
        {
          name: '遂昌县经济商务局',
          val: 55
        },
        {
          name: '经济开发区经贸局',
          val: 45
        },
        {
          name: '青田县农业农村局',
          val: 41
        },
        {
          name: '龙泉市经济商务局',
          val: 40
        },
        {
          name: '青田县发展和改革局',
          val: 33
        },
        {
          name: '庆元县农业农村局',
          val: 33
        },
        {
          name: '遂昌工业园区管理委员会',
          val: 32
        },
        {
          name: '遂昌县卫生健康局',
          val: 31
        },
        {
          name: '景宁县文广旅体局',
          val: 31
        }
      ]
    }
  },
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 8, // 开始无缝滚动的数据量  //this.fourDatata.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  mounted() {
    this.initChart(this.xdata2, this.ydata2, this.type)
  },
  methods: {
    typeChange() {
      if (this.year === '2022年') {
        this.initChart(this.xdata2, this.ydata2, this.type)
      } else {
        this.initChart(this.xdata1, this.ydata1, this.type)
      }
    },
    selectYear() {
      if (this.year === '2022年') {
        this.initChart(this.xdata2, this.ydata2, this.type)
      } else {
        this.initChart(this.xdata1, this.ydata1, this.type)
      }
    },
    initChart(xdata, ydata, type) {
      this.barChart = echarts.init(this.$refs.barChart)
      const option = this.getOption(xdata, ydata, type)
      this.barChart.setOption(option, true)
      window.addEventListener('resize', function () {
        this.barChart.resize()
      })
    },
    getOption(xdata, ydata, type) {
      const options = {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: '#84FFF7' // 0% 处的颜色
            },
            {
              offset: 0.5,
              color: '#6DFFF7' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(0,255,247,0.2)' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        },
        grid: {
          containLabel: true,
          top: '10',
          left: '10'
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        legend: {
          show: true,
          right: '35%',
          bottom: 40,
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xdata,
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 10,
            interval: 0
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
              opacity: 0.5
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.65)',
              fontSize: 10
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                opacity: 0.5,
                width: 0.3
              }
            }
          }
        ],
        series: [
          {
            name: type,
            data: ydata,
            type: 'bar',
            barWidth: 10
          }
        ]
      }
      return options
    }
  }
}
</script>
<style lang='scss' scoped>
#DemandDialog {
  width: 100%;
  height: 100%;
  .wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    &-left {
      width: 50%;
      height: 100%;
      .left-title {
        color: rgba(255, 255, 255, 100);
        font-size: 0.18rem;
      }
      .switch {
        margin-top: 0.1rem;
        /deep/ .el-radio-button__inner {
          color: rgba(255, 255, 255, 0.45);
          background-color: rgba(11, 24, 35, 1);
          border: 1px solid rgba(45, 56, 75, 1);
        }
        /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          color: #fff !important;
          background-color: rgba(0, 137, 255, 0.2);
          border: 1px solid rgb(37, 153, 255) !important;
        }
      }
      .select {
        margin-top: 0.1rem;
        /deep/ .el-select {
          width: 1.5rem;
          margin-right: 0.2rem;
          .el-input__inner {
            height: 0.32rem;
            color: rgba(255, 255, 255, 100);
            background-color: rgba(11, 24, 35, 1);
            border: 1px solid rgba(45, 56, 75, 1);
          }
          .el-input--medium .el-input__icon {
            line-height: 0.32rem;
          }
        }
      }
      #barChart {
        width: 100%;
        height: 70%;
      }
    }
    &-right {
      width: 50%;
      height: 100%;
      .right-title {
        color: rgba(255, 255, 255, 100);
        font-size: 0.18rem;
      }
      .table-wrapper {
        width: 100%;
      }
      .table-header {
        width: 100%;
        display: flex;
        .header1 {
          flex: 1;
          height: 0.4rem;
          line-height: 0.4rem;
          text-align: center;
          background-color: rgba(0, 164, 221, 0.21);
          color: rgba(255, 255, 255, 65);
        }
        .header2 {
          flex: 2;
          height: 0.4rem;
          line-height: 0.4rem;
          text-align: left;
          background-color: rgba(0, 164, 221, 0.21);
          color: rgba(255, 255, 255, 65);
        }
        .header3 {
          flex: 1;
          height: 0.4rem;
          line-height: 0.4rem;
          text-align: left;
          background-color: rgba(0, 164, 221, 0.21);
          color: rgba(255, 255, 255, 65);
        }
      }
      .table-body {
        width: 100%;
        height: 3.5rem;
        overflow: hidden;
        box-sizing: border-box;
        .table-list {
          padding: 0;
          margin: 0;
          width: 100%;
        }
        .line {
          display: flex;
          justify-content: space-around;
          width: 100%;
          .line-item1 {
            flex: 1;
            text-align: left;
            height: 0.4rem;
            line-height: 0.4rem;
            .round {
              margin-left: 0.15rem;
              margin-top: 0.05rem;
              width: 0.3rem;
              height: 0.3rem;
              line-height: 0.3rem;
              border-radius: 50%;
              color: #fff;
              font-size: 0.16rem;
              text-align: center;
              box-shadow: inset 0px 0px 8px 0px rgba(18, 254, 253, 1);
            }
          }
          .line-item2 {
            flex: 2;
            height: 0.4rem;
            line-height: 0.4rem;
            color: #fff;
            font-size: 0.14rem;
            text-align: left;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .line-item3 {
            flex: 1;
            line-height: 0.4rem;
            text-align: center;
            height: 0.4rem;
            color: #fff;
            font-size: 0.14rem;
          }
        }
        .line:nth-child(even) {
          background-color: rgba(0, 18, 34, 0.4);
        }
      }
    }
  }
}
</style>
